import { AnimatePresence, motion } from "framer-motion";
import map from "lodash/map";
import React, { FunctionComponent, ReactElement } from "react";
import Notification from "../../../components/molecules/Notification";
import useCustomizationContext from "../../../hooks/useCustomizationContext";
import "./style.scss";

const AnimatedList = ({ children }: { children: Array<ReactElement<unknown>> }) => (
  <AnimatePresence>{children}</AnimatePresence>
);

const NotificationsArea: FunctionComponent = () => {
  const { notifications } = useCustomizationContext();

  const notificationElements = map(notifications, (notification) => (
    <motion.div
      animate={{ opacity: 1, transition: { delay: 0.05 }, y: 0 }}
      exit={{ opacity: 0, y: 0 }}
      initial={{ opacity: 0, y: 20 }}
      key={notification.key}
      layout
    >
      <div className="NotificationsArea-notification">
        <Notification notification={notification} />
      </div>
    </motion.div>
  ));

  return (
    <div className="NotificationsArea">
      <AnimatedList>{notificationElements}</AnimatedList>
    </div>
  );
};

export default NotificationsArea;
